import { render, staticRenderFns } from "./SubCuradorias.vue?vue&type=template&id=6e9b48b2&scoped=true"
import script from "./SubCuradorias.vue?vue&type=script&lang=js"
export * from "./SubCuradorias.vue?vue&type=script&lang=js"
import style0 from "./SubCuradorias.vue?vue&type=style&index=0&id=6e9b48b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9b48b2",
  null
  
)

export default component.exports